import * as React from "react"
import { login as apiLogin } from "../lib/faion"

/**
 * The whole page until somebody is signed in — one card, nothing behind it.
 *
 * `reason` carries a refusal the backend already gave, which is a different thing from a
 * failed sign-in: a subscription that does not cover this is not a mistyped password, and
 * telling somebody to "check their credentials" when their account is simply not entitled
 * sends them to change a password that was never wrong.
 */
export const SignIn: React.FC<{ onDone: () => void; reason?: string }> =
({ onDone, reason }) => {
  const [email, setEmail] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [error, setError] = React.useState("")
  const [busy, setBusy] = React.useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true); setError("")
    try {
      await apiLogin(email, password)
      onDone()
    } catch (e) {
      // Say what failed. "Something went wrong" on a login form is how somebody concludes
      // the product is broken when in fact they mistyped a password.
      setError(e instanceof Error ? e.message : String(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="sf-gate">
      <form className="sf-card" onSubmit={submit}>
        <div className="sf-brand-mark">FS</div>
        <h1>Faion Suite</h1>
        <p>Sign in with your faion.net account. Your documents stay on your own machine.</p>

        <label className="sf-field">
          <span>email</span>
          <input type="email" value={email} required autoComplete="username"
                 autoFocus onChange={e => setEmail(e.target.value)} />
        </label>
        <label className="sf-field">
          <span>password</span>
          <input type="password" value={password} required autoComplete="current-password"
                 onChange={e => setPassword(e.target.value)} />
        </label>

        <button className="sf-btn" disabled={busy}>
          {busy ? "signing in…" : "Sign in"}
        </button>

        {error && <p className="sf-err">{error}</p>}
        {!error && reason && reason !== "not signed in" && (
          <p className="sf-err">{reason}</p>
        )}
      </form>
    </div>
  )
}
